<template>
  <nav>
    <v-app-bar dense class="" color="primary">
      <v-toolbar-items>
        <v-btn dark @click="gohome" class="hidden-xs-only" text>
          <v-icon>home</v-icon>
          Lobby</v-btn>
        <v-menu open-on-hover offset-y  >
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="goproduct" dark v-bind="attrs" v-on="on" class="" text>
              <v-icon>mdi-package</v-icon>
              Produk</v-btn>
          </template>
<!--          <v-list>-->
<!--            <v-list-item dense ripple-->
<!--              v-for="(item, index) in category"-->
<!--              :href="item.href"-->
<!--              :key="index">-->
<!--              <v-img width="20px" class="mr-2" :src="item.image"/>-->
<!--              <v-list-item-title>{{ item.name }}</v-list-item-title>-->
<!--            </v-list-item>-->
<!--          </v-list>-->
        </v-menu>
        <v-btn dark v-if="isAdmin" @click="goTrxadmin" class="hidden-xs-only" text>
          <v-icon>shopping_cart</v-icon>
          Transaksi</v-btn>
        <v-menu v-if="!isseller && !isAdmin" open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn dark v-bind="attrs" v-on="on" class="" text>
              <v-icon>shopping_cart</v-icon>
              Transaksi</v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in menutrx"
              :href="item.href"
              @click="item.click"
              :key="index"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu v-if="isseller && !isAdmin" open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn dark v-bind="attrs" v-on="on" class="" text>
              <v-icon>shopping_cart</v-icon>
              Transaksi</v-btn>
          </template>
          <v-list>
            <v-list-item
                v-for="(item, index) in menutrxwithseller"
                :href="item.href"
                @click="item.click"
                :key="index"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn dark @click="gosupplier" class="hidden-xs-only" text>
          <v-icon>store</v-icon>
          Suplier</v-btn>
        <v-btn dark @click="gochat" class="hidden-xs-only" text>
          <v-icon>message</v-icon>
          Chat</v-btn>
        <v-menu v-if="isAdmin" open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on"  dark class="hidden-xs-only" text>
              <v-icon class="mr-1">payments</v-icon>
              Administrator</v-btn>
          </template>
          <v-list>
            <v-list-item
                v-for="(item, index) in menuadmin"
                :href="item.href"
                @click="item.click"
                :key="index"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

      </v-toolbar-items>
<!--      <v-toolbar-items class="">-->
<!--        <v-btn dark @click="gofeed" class="" text>-->
<!--          <v-icon class="mr-1">topic</v-icon>-->
<!--          Posko</v-btn>-->
<!--      </v-toolbar-items>-->
      <v-spacer/>
      <v-toolbar-items class="hidden-xs-only">
        <v-text-field flat @keypress="keyturun"  v-model="cari" rounded solo dense hide-details clearable class="mt-1" label="Cari Produk atau Suplier" prepend-inner-icon="mdi-magnify" background-color="white"></v-text-field>
      </v-toolbar-items>
    </v-app-bar>
  </nav>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'UserToolbar',
  data: () => ({
    cari: '',
    menutrx: [
      {
        icon: 'account_circle',
        href: '#',
        title: 'Pembelian',
        click: e => {
          window.getApp.$emit('TRX_BELI')
        }
      },
      {
        icon: 'account_circle',
        href: '#',
        title: 'Penjualan',
        click: e => {
          window.getApp.$emit('REG_SELLER')
        }
      }
    ],
    menutrxwithseller: [
      {
        icon: 'account_circle',
        href: '#',
        title: 'Pembelian',
        click: e => {
          window.getApp.$emit('TRX_BELI')
        }
      },
      {
        icon: 'account_circle',
        href: '#',
        title: 'Penjualan',
        click: e => {
          window.getApp.$emit('TRX_JUAL')
        }
      }
    ],
    menuadmin: [
      {
        icon: 'account_circle',
        href: '#',
        title: 'Banner',
        click: e => {
          window.getApp.$emit('MENU_ADM_SLIDER')
        }
      },
      {
        icon: 'account_circle',
        href: '#',
        title: 'Produk',
        click: e => {
          window.getApp.$emit('MENU_ADM_PRODUK')
        }
      },
      {
        icon: 'account_circle',
        href: '#',
        title: 'Topup',
        click: e => {
          window.getApp.$emit('MENU_ADM_TOPUP')
        }
      },
      {
        icon: 'account_circle',
        href: '#',
        title: 'Cashout',
        click: e => {
          window.getApp.$emit('MENU_ADM_CASHOUT')
        }
      },
      {
        icon: 'account_circle',
        href: '#',
        title: 'Monitoring Saldo',
        click: e => {
          window.getApp.$emit('MENU_ADM_SALDO')
        }
      },
      {
        icon: 'account_circle',
        href: '#',
        title: 'Mutasi Bank',
        click: e => {
          window.getApp.$emit('MENU_ADM_MUTASIBANK')
        }
      },
      {
        icon: 'account_circle',
        href: '#',
        title: 'Management User',
        click: e => {
          window.getApp.$emit('MENU_ADM_USER')
        }
      }
    ]
  }),
  computed: {
    ...mapState('ProductStore', ['category']),
    ...mapState('authentication', ['isAdmin', 'isseller'])
  },
  methods: {
    ...mapActions('ProductStore', ['getSupplierCari', 'getProducPricingcari']),
    gochat () {
      this.$router.push('/chat')
    },
    gosupplier () {
      this.$router.push('/supplier')
    },
    goTrxadmin () {
      this.$router.push('/trxadm')
    },
    gofeed () {
      this.$router.push('/feeds')
    },
    gohome () {
      if (this.$route.name === 'home') {
        location.reload()
      } else {
        this.$router.push('/home')
      }
    },
    goproduct () {
      if (this.$route.name === 'product') {
        location.reload()
      } else {
        this.$router.push('/product')
      }
    },
    keyturun (e) {
      if (e.code === 'Enter') {
        this.$router.push({ path: '/cari', query: { cari: this.cari } })
        this.getSupplierCari(this.cari)
        this.getProducPricingcari(this.cari)
        this.$ga.event({
          eventCategory: 'Products',
          eventAction: 'search',
          eventLabel: 'CariProduk',
          eventValue: this.cari
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
